import Head from 'next/head';
import Link from 'next/link';
import Footer from '@/components/Footer';
import { WebdienstFooterCode } from '@/components/codeHighlights/FooterCode';
import { FooterIconsCode } from '@/components/codeHighlights/FooterIconsCode';

const Page = () => {
  return (
    <>
      <Head>
        <title>Webdienst-Footer</title>
      </Head>
      <h1>Webdienst-Footer</h1>
      <p className="lead">
        Verwenden Sie diesen Footer für{' '}
        <Link href={'/webdienste'} legacyBehavior>
          <a>FHNW-Webdienste</a>
        </Link>
        .
      </p>

      <div className="mt-5">
        <Footer />
      </div>
      <div className="mt-5">
        <WebdienstFooterCode />
      </div>

      <div className="mt-5">
        <h2>Social Media Icons</h2>
        <FooterIconsCode />
      </div>
    </>
  );
};

export default Page;
